import { MNSproCloudApi } from '../..';
import { ResourcesSettings } from '../../api/v2';

export class ResourcesSettingsService {
  static async getSettings(
    authToken: string,
    organizationId: string,
  ): Promise<ResourcesSettings> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ResourcesApiFactory(config);

    const result = await api.getSettings(organizationId);

    return result.data;
  }

  static async updateSettings(
    authToken: string,
    organizationId: string,
    settings: ResourcesSettings,
  ): Promise<ResourcesSettings> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ResourcesApiFactory(config);

    const result = await api.updateSettings(organizationId, settings);

    return result.data;
  }
}
